module.exports = __webpack_public_path__ + "static/media/Logo.3d1e8f77.svg";